import React, { useState, useRef, useEffect } from "react";
import "./ThayDoiBank.scss";
import axios from "axios";
import { getFromlocalstorage } from "../../../../../component/MaHoaDuLieu/MaHoaDuLieu";
import { useUser } from "../../../../../component/UserProvider/UserProvider";
import Notify from "../../../../../component/Notify/Notify";
import { BankList } from "../../../../../LayoutMobile/CaiDatMobile/CaiDatRutTien/ThemTkRutTien/NganHang/BankList";

const ThayDoiBank = () => {
  const [message, setMessage] = useState("");
  const [typeNoti, setTypeNoti] = useState("error");

  const { user, fetchUser } = useUser();
  const hasFetched = useRef(false);

  // Danh sách ngân hàng Thái Lan
  const bankList = [
    {
      id: 1,
      name: "ธนาคารกสิกรไทย",
      shortName: "KBANK",
      code: "KBANK",
    },
    {
      id: 2,
      name: "ธนาคารกรุงเทพ",
      shortName: "BBL",
      code: "BBL",
    },
    {
      id: 3,
      name: "ธนาคารกรุงไทย",
      shortName: "KTB",
      code: "KTB",
    },
    {
      id: 4,
      name: "ธนาคารไทยพาณิชย์",
      shortName: "SCB",
      code: "SCB",
    },
    {
      id: 5,
      name: "ธนาคารกรุงศรีอยุธยา",
      shortName: "BAY",
      code: "BAY",
    },
    {
      id: 6,
      name: "ธนาคารทหารไทยธนชาต",
      shortName: "TTB",
      code: "TTB",
    },
    {
      id: 7,
      name: "ธนาคารออมสิน",
      shortName: "GSB",
      code: "GSB",
    },
    {
      id: 8,
      name: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
      shortName: "BAAC",
      code: "BAAC",
    },
    {
      id: 9,
      name: "ธนาคารเกียรตินาคินภัทร",
      shortName: "KKP",
      code: "KKP",
    },
    {
      id: 10,
      name: "ธนาคารซีไอเอ็มบี ไทย",
      shortName: "CIMBT",
      code: "CIMBT",
    },
    {
      id: 11,
      name: "ธนาคารยูโอบี",
      shortName: "UOB",
      code: "UOB",
    },
    {
      id: 12,
      name: "ธนาคารแลนด์ แอนด์ เฮ้าส์",
      shortName: "LH Bank",
      code: "LHBANK",
    },
    {
      id: 13,
      name: "ธนาคารไอซีบีซี (ไทย)",
      shortName: "ICBC",
      code: "ICBC",
    },
    {
      id: 14,
      name: "ธนาคารอิสลามแห่งประเทศไทย",
      shortName: "IBANK",
      code: "IBANK",
    },
  ];

  // Mặc định chọn ngân hàng
  const [method, setMethod] = useState("bank");

  const [address, setAddress] = useState("");
  const [selectedBank, setSelectedBank] = useState(
    "กรุณาเลือกธนาคาร"
  );

  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");

  const [showPopup, setShowPopup] = useState(false);

  const apiUrl = process.env.REACT_APP_API_BACKEND;
  const data = JSON.parse(getFromlocalstorage("data_u"));

  useEffect(() => {
    if (data && !hasFetched.current) {
      fetchUser(data._id);
      hasFetched.current = true;
    }
  }, [data, fetchUser]);

  useEffect(() => {
    if (user && user.crypto_wallet) {
      setAddress(user.crypto_wallet);
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // BANK
      if (method === "bank") {
        if (
          !selectedBank ||
          selectedBank === "กรุณาเลือกธนาคาร"
        ) {
          setMessage("กรุณาเลือกธนาคาร");
          setTypeNoti("error");
          return;
        }

        if (!accountNumber) {
          setMessage("กรุณากรอกเลขที่บัญชี");
          setTypeNoti("error");
          return;
        }

        if (!accountName) {
          setMessage("กรุณากรอกชื่อเจ้าของบัญชี");
          setTypeNoti("error");
          return;
        }

        const response = await axios.post(
          `${apiUrl}/postbank/${user._id}`,
          {
            bank_name: selectedBank,
            bank_account_number: accountNumber,
            bank_account_name: accountName,
          }
        );

        if (response.status === 200) {
          setMessage("อัปเดตข้อมูลธนาคารสำเร็จ!");
          setTypeNoti("success");

          fetchUser(data._id);
        } else {
          setMessage(
            response.data.message || "อัปเดตข้อมูลไม่สำเร็จ"
          );
          setTypeNoti("error");
        }
      }

      // USDT
      else if (method === "crypto") {
        if (!address) {
          setMessage("กรุณากรอกที่อยู่กระเป๋าเงิน");
          setTypeNoti("error");
          return;
        }

        const response = await axios.post(
          `${apiUrl}/postcryto_wallet/${user._id}`,
          {
            cryto_wallet: address,
          }
        );

        if (response.status === 200) {
          setMessage("อัปเดตกระเป๋า USDT สำเร็จ!");
          setTypeNoti("success");

          fetchUser(data._id);
        } else {
          setMessage(
            response.data.message || "อัปเดตข้อมูลไม่สำเร็จ"
          );
          setTypeNoti("error");
        }
      }
    } catch (error) {
      setMessage("เกิดข้อผิดพลาดในการอัปเดตข้อมูล");
      setTypeNoti("error");

      console.error(error);
    }
  };

  return (
    <div className="el-tab-pane">
      <div className="form-overlay-inside">
        <form
          className="withdraw-form"
          onSubmit={handleSubmit}
        >
          {/* Chọn phương thức */}
          <div className="form-item">
            <label>ประเภทช่องทาง</label>

            <div className="radio-group">
              <label
                className={`radio ${
                  method === "bank" ? "checked" : ""
                }`}
              >
                <input
                  type="radio"
                  value="bank"
                  checked={method === "bank"}
                  onChange={() => setMethod("bank")}
                />

                ธนาคาร
              </label>

              <label
                className={`radio ${
                  method === "crypto" ? "checked" : ""
                }`}
              >
                <input
                  type="radio"
                  value="crypto"
                  checked={method === "crypto"}
                  onChange={() => setMethod("crypto")}
                />

                USDT
              </label>
            </div>
          </div>

          {/* BANK */}
          {method === "bank" && (
            <>
              <div
                className="withdraw_nganhang_input_tong width_pass border_bottom"
                onClick={() => setShowPopup(true)}
              >
                <div className="withdraw_nganhang_title_input">
                  ธนาคาร
                </div>

                <div className="withdraw_nganhang_input">
                  {selectedBank}
                </div>

                <div className="withdraw_nganhang_arrow">
                  <img
                    src="/caidat/arrow.png"
                    alt=""
                  />
                </div>
              </div>

              <div className="form-item required">
                <label>เลขที่บัญชี</label>

                <input
                  type="text"
                  inputMode="numeric"
                  placeholder={
                    user?.bank_account_number ||
                    "กรอกเลขที่บัญชี"
                  }
                  value={accountNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(
                      /[^0-9]/g,
                      ""
                    );

                    setAccountNumber(value);
                  }}
                />
              </div>

              <div className="form-item required">
                <label>ชื่อเจ้าของบัญชี</label>

                <input
                  type="text"
                  placeholder={
                    user?.bank_account_name ||
                    "กรอกชื่อเจ้าของบัญชี"
                  }
                  value={accountName}
                  onChange={(e) =>
                    setAccountName(e.target.value)
                  }
                />
              </div>
            </>
          )}

          {/* USDT */}
          {method === "crypto" && (
            <>
              <div className="form-item required">
                <label>ที่อยู่กระเป๋าเงิน</label>

                <input
                  type="text"
                  placeholder={
                    user?.cryto_wallet ||
                    "กรอกที่อยู่กระเป๋าเงิน"
                  }
                  value={address}
                  onChange={(e) =>
                    setAddress(e.target.value)
                  }
                />
              </div>

              <div className="form-item">
                <label>เครือข่าย</label>
                <span>TRC20</span>
              </div>
            </>
          )}

          {/* Buttons */}
          <div className="form-item buttons">
            <button
              type="submit"
              className="btn primary"
            >
              อัปเดต
            </button>

            <button
              type="reset"
              className="btn reset"
              onClick={() => {
                setAccountNumber("");
                setAccountName("");
                setAddress("");
              }}
            >
              รีเซ็ต
            </button>
          </div>
        </form>
      </div>

      <BankList
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        selectedBank={selectedBank}
        setSelectedBank={setSelectedBank}
        bankList={bankList}
      />

      {message && (
        <Notify
          message={message}
          type={typeNoti}
          setcontent={setMessage}
        />
      )}
    </div>
  );
};

export default ThayDoiBank;